module.exports = __webpack_public_path__ + "img/patrick.8298b59f.jpg";